import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

interface ComponentProps {
    open: boolean;
    handleClose: () => any;
    handleDelete: () => any;
}

export default function DeleteMenu({ open, handleClose, handleDelete } : ComponentProps) {
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="delete-alert-box"
                aria-describedby="delete-alert-box"
            >
                <DialogTitle id="delete-alert-box-title">
                    {"Törlési felhívás"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-alert-box-description">
                        Biztosan törlöd az alábbi elemet?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Mégse</Button>
                    <Button variant={"contained"} color={"error"} onClick={() => {
                        handleDelete()
                        handleClose()
                    }}>
                        Törlés
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}